<div class="custom-name-modal">
    <div class="modal-header">
        <span class="modal-title">{{localize(langSection.CustomNameModal, langText.EditLocationName)}}</span>
        <span class="ups-icon ups-icon-x close-icon" role="button" (click)="dismissModal()"></span>
    </div>
    <div class="modal-body">
        <div class="d-flex flex-column">
            <span class="custom-name-warning">
                {{localize(langSection.CustomNameModal, langText.CustomNameWarning)}}
            </span>
            <div class="d-flex info-text">
                <label class="pe-2">{{localize(langSection.Term, langText.Location)}}:</label>
                <span>{{locationProfile.slicName}}</span>
            </div>
            <div class="d-flex info-text">
                <label class="pe-2">{{localize(langSection.CustomNameModal, langText.CurrentLocationName)}}:</label>
                <span>{{locationProfile.customName}}</span>
            </div>
            @if (!!locationProfile.customNameLastUpdatedBy) {
<div class="d-flex info-text">
                <label class="pe-2">{{localize(langSection.CustomNameModal, langText.LastUpdated)}}:</label>
                <span>{{locationProfile.customNameLastUpdatedAt | localizedDate: 'MM/DD h:mm A':"yyyy/MM/DD HH:mm":offset}} {{localize(langSection.Term, langText.By) | lowercase}} {{locationProfile.customNameLastUpdatedBy}}</span>
            </div>
}
            <div class="d-flex flex-column">
                <label class="input-label">{{localize(langSection.CustomNameModal, langText.NewLocationName)}}</label>
                <input class="form-control" type="text" maxlength="30" [value]="customName" (input)="customName = $event.target.value">
            </div>
        </div>
    </div>
    <div class="modal-footer">
        @if (saveFailed) {
<span class="error-message">{{localize(langSection.CustomNameModal, langText.SaveFailed)}}</span>
}
        <button class="btn btn-green" (click)="setCustomName()" [disabled]="isSaving | async">{{localize(langSection.Term, langText.Submit)}}</button>
    </div>
</div>